export { default as storeService } from './store';